import LogoIcon from '@/shared/assets/logo-icon.png';
import { Link } from 'react-router-dom';

export function Logo() {
  return (
    <Link to="/" className="block">
      <img src={LogoIcon} alt="Piggo" width={47} height={36} />
    </Link>
  );
}
